import { render, staticRenderFns } from "./EventProgramBlock.vue?vue&type=template&id=60ab93ac"
import script from "./EventProgramBlock.vue?vue&type=script&lang=js"
export * from "./EventProgramBlock.vue?vue&type=script&lang=js"
import style0 from "./EventProgramBlock.vue?vue&type=style&index=0&id=60ab93ac&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports